import { Card, FormControl, FormHelperText, Grid2, IconButton, Slide, Tooltip } from "@mui/material"
import MaterialButton from "../../../../components/MaterialButton";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialBox from "../../../../components/MaterialBox";
import { useContext, useEffect, useState } from "react";
import MaterialTypography from "../../../../components/MaterialTypography";
import UserDetailsContext from "../../../../context/auth";
import { Close, Send } from "@mui/icons-material";
import BASEURL from "../../../Utils/Baseurl";
import axios from "axios";
import { useLoading } from "../../../../context/loading";
import Swal from "sweetalert2";
import { getMyLeaveDetailsQuery, submitMutationWFh } from "./wfhData";

const WorkFromHomeForm = ({
    wfhOpen,
    setWfhOpen,
    selectedDate
}) => {
  
  const { user } = useContext(UserDetailsContext);
  const {setCirleLoading } = useLoading();
  const [Visiable, setVisiable] = useState(false);
  const [Countdata, setCountdata] = useState(""); 
  const [leavecount, setleavecount] = useState([]);  
  const [wfhData, setwfhData] = useState({
    requestedDate: new Date().toISOString().split("T")[0],
    startDate: selectedDate,
    endDate: "",
    totalDays: "",
    reason: "",
    startDateStatus: "unchecked",
    endDateStatus: "unchecked",
    reasonStatus: "unchecked",
  });
  
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  //These are based on wfhData State, 
  // thus declared after the state definition
  let date1 = new Date(wfhData.startDate);
  let date2 = new Date(wfhData.endDate);
  let Difference_In_Time = date2.getTime() - date1.getTime();
  let Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
  let Total_Days = Days + 1;


  useEffect(() => {
    if(wfhOpen) {
      //Leave Type Query
      getleavetype();
      //Setting Selected Date from the calendar
      setwfhData({
        ...wfhData,
        requesteddatestatus: "success",
        startDate: selectedDate,
        startDateStatus: selectedDate ? "success" : "unchecked",
      });
    }
  },[wfhOpen])
  
  //Total Days
  useEffect(() => {
    if (Total_Days <= 0) {
      setVisiable(true); // Set to true if Total_Days is negative
    } else {
      setVisiable(false); // Set to false otherwise
    }
  }, [Total_Days]);

  //Query for Leave Type
  const getleavetype = async () => {

      try {
        const response = await axios.post(
          BASEURL,
          {
            query: getMyLeaveDetailsQuery,
            variables: { id: user?.id },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
  
        // Check and handle the response
        const data = response.data.data.leaveDetailsByMe;
  
        // Format data for dropdown
        const formattedOptions = data.map((item) => ({
          value: item.leaveType?.id,
          label: item.leaveType?.name.replace(/_/g, " ").toUpperCase(),
        }));
  
        const temp = [];
        data?.map((item) => {
          if (
            item?.leaveType?.name !== "loss_of_pay" &&
            item?.leaveType?.name !== "paternity_leave" &&
            item?.leaveType?.name !== "maternity_leave" &&
            item?.leaveType?.name !== "casual_leave" &&
            item?.leaveType?.name !== "sick_leave" &&
            item?.leaveType?.name !== "restricted_holiday" &&
            item?.leaveType?.name !== "earned_leave" &&
            item?.leaveType?.name !== "annual_leave"
          ) {
            temp.push(item);
          }
        });
  
        const formatted = temp.map((item) => ({
          count: item.leaveCount - item.takedLeave,
          leavetype: item.leaveType?.name,
          id: item.leaveType?.id,
        }));
  
        let filvalue = formatted.filter((val) => val.id !== undefined);
        const counts = filvalue[0]?.count;
  
        setleavecount(filvalue);
        setCountdata(counts);

      } catch (error) {
        console.error("ERRorrrrr", error.message);
  
        setConfirmationDialog({
          open: true,
          title: "Error message",
          message:
            "Sorry for your inconvience, there is some issue in our network. Please try again later.",
          showCancel: true,
          showConfirm: false,
  
          onCancel: () => {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
          },
        });
      }
  };

  //Create API
  const onWfhSubmit = async () => {
    setCirleLoading(true);

    const { startDate, endDate, reason } = wfhData;
    try {
      const response = await fetch(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: submitMutationWFh,
          variables: {
            input: {
              userId: user?.id,
              startDate: startDate,
              endDate: endDate,
              reason: reason,
              leaveType: leavecount[0]?.id,
              teamleaderId: user?.teamleader,
              screenName: "Work From Home Approval",
            },
          },
        }),
      });

      const data = await response.json();

      let Val = data.data?.requestForWfh;
      let success = data.data?.requestForWfh?.success
      let message = data.data?.requestForWfh?.message

      Swal.fire({
            position: "center",
            icon: success?"success":"error",
            title: message,
            showConfirmButton: false,
            timer: 2500,
          });
      if(success){
        handleCloseWfh();
      }

      setCirleLoading(false);
    } catch (error) {
      console.error("responseError:", error);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  //Handle Change
  const handleWfhDataChange = (event) => {
    let wfhState = { ...wfhData };
    switch (event.target.name) {
      case "reason":
        {
          const descriptionRegex = new RegExp("^([\\s\\S]{10,100})$");

          if (descriptionRegex.test(event.target.value?.trim())) {
            wfhState[event.target.name + "Status"] = "success";
          } else {
            wfhState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "startDate":
        {
          if (event.target.value?.trim()) {
            wfhState[event.target.name + "Status"] = "success";
          } else {
            wfhState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "endDate":
        {
          if (event.target.value?.trim()) {
            wfhState[event.target.name + "Status"] = "success";
          } else {
            wfhState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;

      default:
        break;
    }
    wfhState[event.target.name] = event.target.value;

    setwfhData(wfhState);
  };

  //Submit Validation
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      wfhData.startDateStatus === "success" &&
      wfhData.endDateStatus === "success" &&
      wfhData.reasonStatus === "success" &&
      !Visiable
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  //Close Form Function
  const handleCloseWfh = () => {
    setWfhOpen(false);
    setTimeout(() => {
      setwfhData({
        requestedDate: new Date().toISOString().split("T")[0],
        startDate: "",
        endDate: "",
        totalDays: "",
        reason: "",
        startDateStatus: "unchecked",
        endDateStatus: "unchecked",
        reasonStatus: "unchecked",
      });
    },1000);
  };

   return (
    <>
      {wfhOpen && (
        <MaterialBox
          onClick={handleCloseWfh}
          sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              bgcolor: "rgba(0, 0, 0, 0.59)",
              zIndex: 2,
          }}
        />
      )}
      <Slide
      timeout={1000}
      direction="right"
      in={wfhOpen}
      mountOnEnter unmountOnExit>
          <MaterialBox
          p={1}
          className="custom-dialog-box"
          open={wfhOpen}
          onClose={(event, reason) => {
              if (reason !== 'backdropClick') handleCloseWfh();
          }}>
            {/* Form Title */}
              <MaterialBox>
                <Grid2 container alignItems="center">
                    {/* Title */}
                    <Grid2 size={{xs:10}} display="flex" justifyContent="center">
                      <MaterialTypography variant="h5" fontWeight="medium">
                        WFH Form
                      </MaterialTypography>
                    </Grid2>

                    <Grid2 size={{xs:2}} display="flex" justifyContent="flex-end">
                    {/* Edit button to be implemented when view page exists*/}

                    {/* Close button */}
                    <Tooltip title="Close" disableInteractive enterDelay={1200}>
                      <IconButton onClick={handleCloseWfh}>
                        <Close fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Grid2>

                </Grid2>
              </MaterialBox>
              {selectedDate < new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().slice(0,10) ? (
                // Cannot Apply WFH Error Throwing
                  <Card variant="outlined" raised style={{ padding: "12px", borderRadius: "10px", margin: "10px" , textAlign: "center" }}>
                    <MaterialTypography variant="body2" color="error">
                      Work From Home cannot be applied on {new Date(selectedDate).toDateString()}.
                    </MaterialTypography>
                  </Card>  
              )
              :
              (
              <>
              {/* Form Content */}
                <MaterialBox p={1}>
                      <Grid2 container spacing={1}>
                        <Grid2 size={{ xs: 6, sm: 6 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                            >
                              Requested Date <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="requestedDate"
                            value={wfhData.requestedDate}
                            readOnly
                            error={wfhData.requesteddatestatus === "error"}
                            success={wfhData.requesteddatestatus === "success"}
                          />
                        </Grid2>
                        <Grid2 size={{ xs: 6, sm: 6 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                            >
                              Start Date <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="startDate"
                            type="date"
                            onChange={handleWfhDataChange}
                            value={wfhData.startDate}
                            error={wfhData.startDateStatus === "error"}
                            success={wfhData.startDateStatus === "success"}
                            inputProps={{
                              min: new Date(
                                new Date().setDate(new Date().getDate() - 7)
                              ) // 7 days before today
                                .toISOString()
                                .split("T")[0],
                            }}
                          />
                        </Grid2>

                        <Grid2 size={{ xs: 6, sm: 6 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                            >
                              End Date <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="endDate"
                            type="date"
                            onChange={handleWfhDataChange}
                            value={wfhData.endDate}
                            error={wfhData.endDateStatus === "error"}
                            success={wfhData.endDateStatus === "success"}
                            inputProps={{
                              min: new Date(
                                new Date().setDate(new Date().getDate() - 7)
                              ) // 7 days before today
                                .toISOString()
                                .split("T")[0],
                            }}
                          />
                        </Grid2>
                        <Grid2 size={{ xs: 6, sm: 6 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                            >
                              Total Days <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="totalDays"
                            placeholder="Auto Generated"
                            value={Total_Days || 0}
                            disabled
                          />
                          {Total_Days > Countdata && (
                            <FormControl error>
                              <FormHelperText>
                                {`  Available for ${Countdata} days only`}
                              </FormHelperText>
                            </FormControl>
                          )}

                          {Visiable && (
                            <FormControl error>
                              <FormHelperText>
                                Total Days is Not Allowed in Minus or Zero Units
                              </FormHelperText>
                            </FormControl>
                          )}
                        </Grid2>

                        <Grid2 size={{ xs: 12, sm: 12 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                            >
                              Reason <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="reason"
                            onChange={handleWfhDataChange}
                            multiline
                            rows={5}
                            value={wfhData.reason}
                            error={wfhData.reasonStatus === "error"}
                            success={wfhData.reasonStatus === "success"}
                          />
                          {wfhData.reasonStatus === "error" && (
                            <FormControl error>
                              <FormHelperText>
                                Reason should be a minimum 10 characters maximum 100
                                characters long.
                              </FormHelperText>
                            </FormControl>
                          )}
                        </Grid2>
                      </Grid2>
                </MaterialBox>

                {/* Form Actions */}
                <MaterialBox
                display="flex"
                justifyContent="flex-end"
                alignItems="center">
                    <MaterialBox>      
                      {/* Delete To be implemented when view page exists */}
    
                    </MaterialBox>
                    <MaterialBox
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center">  
                            <>
                              <MaterialButton
                                sx={{ m: 1, marginLeft: "4px" }}
                                variant="gradient"
                                color="dark"
                                size="small"
                                endIcon={<Send />}
                                disabled={!checkAllFields()}
                                onClick={onWfhSubmit}
                              >
                                Apply
                              </MaterialButton>
                            </>                     
                    </MaterialBox>
                </MaterialBox>
              </>
              )
              }
          
          </MaterialBox>
      </Slide>
    </>
  );
}

export default WorkFromHomeForm